var _g, _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3401_4601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 19.9371C13 12.7921 18.7921 7 25.9371 7H64.0629C71.2079 7 77 12.7921 77 19.9371V58.0629C77 65.2079 71.2079 71 64.0629 71H25.9371C18.7921 71 13 65.2079 13 58.0629V19.9371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9371 7.40428H64.0629C70.9846 7.40428 76.5957 13.0154 76.5957 19.9371V58.0629C76.5957 64.9846 70.9846 70.5957 64.0629 70.5957H25.9371C19.0154 70.5957 13.4043 64.9846 13.4043 58.0629V19.9371C13.4043 13.0154 19.0154 7.40428 25.9371 7.40428Z",
    stroke: "#B1C1CF",
    strokeWidth: 0.808569
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.9716,
    y: 23.1621,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8288 35.1945C48.5637 34.9384 49.3365 34.8082 50.1148 34.8093C50.8996 34.8093 51.6544 34.9401 52.3588 35.1801M52.3588 35.1801C55.0444 36.0981 56.9716 38.6193 56.9716 41.5857C56.9716 45.3285 53.902 48.3621 50.1148 48.3621H38.1148C35.2744 48.3621 32.9716 46.0869 32.9716 43.2801C32.9716 40.4733 35.2744 38.1981 38.1148 38.1969C38.4491 38.1969 38.7826 38.2291 39.1108 38.2929M52.3588 35.1801C51.976 31.7949 49.0708 29.1621 45.5428 29.1621C41.7556 29.1621 38.686 32.1957 38.686 35.9385C38.685 36.7425 38.8289 37.54 39.1108 38.2929M39.1108 38.2929C39.7747 38.4219 40.4068 38.6804 40.9708 39.0537",
    stroke: "#243251",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3401_4601",
    x: 0.0628891,
    y: 0.531445,
    width: 89.8742,
    height: 89.8742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.46856
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.46856
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.686275 0 0 0 0 0.776471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3401_4601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3401_4601",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile2);
export default __webpack_public_path__ + "static/media/Mobile2.dd12d9cdc8c90b20e1a52011c6ee1ebc.svg";
export { ForwardRef as ReactComponent };